/*-------------------------------------------------------------------------------

  エラーメッセージ一元管理

--------------------------------------------------------------------------------*/

export const TCCF7_CONFIG = Object.freeze({
  KEY : {
    CONFIRM  : 'tccf7_confirm_values',
    OPTION   : 'tccf7_option_values',
    COMPLETE : 'tccf7_complete_values',
    COMMON   : 'tccf7_common'
  },
  TARGET : {
    CONFIRM  : 'confirm_target',
    INPUT    : 'input_target',
    COMPLETE : 'complete_target',
    THANKS   : 'complete_page',
    AJAX     : 'ajax_url'
  },
  SELECTORS : {
    BTN : {
      CONFIRM: '.wpcf7-confirm',
      BACK:    '.wpcf7-back',
      SUBMIT:  '.wpcf7-submit'
    },
    HEADER     : '.anchor-header',
    LABEL      : '.wpcf7-list-item-label',
    ACCEPTANCE : '.wpcf7-acceptance',
    HONEYPOT   : '.wpcf7-top_secret',
    BTN_WRAP   : '.tccf7-btn_wrap',
  },
  ATTRIBUTES : {
    NONCE : 'data-nonce',
    ID    : 'data-form-id'
  },
  ACTION : {
    SET   : 'tccf7_set_confirm_ready',
    CLEAR : 'tccf7_clear_confirm_ready'
  },
  CLASSNAME : {
    NONE : 'tccf7_none',
    STEP : {
      INPUT    : 'step-input',
      CONFIRM  : 'step-confirm',
      COMPLETE : 'step-complete',
      ERROR    : 'step-error'
    }
  },
  MESSAGE : {
    SYSTEM_ERROR: 'システムエラーが発生しました。',
    /*----------------------------------------
      submit
    ------------------------------------------*/
    SUBMIT_ERROR: '送信は失敗しました。入力に不備がある可能性があります。',
    SUBMIT_PROCESS_ERROR: '送信中に問題が発生しました。ページを再読み込みして、もう一度お試しください。',
    /*----------------------------------------
      tccf7Confirm：setConfirm
    ------------------------------------------*/
    CONFIRM_NO_THROW_ERROR: '確認画面が表示されていません。送信する内容を確認してください。',
    CONFIRM_DISPLAY_ERROR: '確認画面の表示に失敗しました。ページを再読み込みしてください。',
    CONFIRM_PAGE_DISPLAY_ERROR: '申し訳ありません。内容確認ページの表示に失敗しました。お手数ですが、ページを再読み込みして再度お試しください。',
    CONFIRM_BACK_ERROR: '申し訳ありません。入力画面ページの表示に失敗しました。お手数ですが、ページを再読み込みして再度お試しください。',
    /*----------------------------------------
      tccf7HoneyPot:checkHoneyPot
    ------------------------------------------*/
    HONEY_POT: 'ハニーポット検知',
    HONEY_POT_LOG:  '入力不可項目で入力を検知しました。',
    HONEY_POT_ERROR: '入力内容に不備があります。画面を更新して再度お試しください。',
    HONEY_POT_STOP: '入力内容に不備があります。メールは送信されませんでした。',
    /*----------------------------------------
      checkNonce
    ------------------------------------------*/
    NONCE_ERROR: 'サーバーとの通信に失敗しました。',
    NONCE_MOVE_ERROR: '確認画面への遷移に失敗しました',
    /*----------------------------------------
      skipMail
    ------------------------------------------*/
    VALIDATION_ERROR: '入力内容に不備があります。確認して再度お試しください。',
    NETWORK_ERROR: '通信エラーが発生しました。画面を更新して再度お試しください。',
  }
});
